import { makeNamespacedLog } from '@sb/log';
import { EventEmitter } from '@sb/utilities';
import type { ListenerType } from '@sb/utilities/src/EventEmitter';
import { globalCache } from '@sbrc/utils';

import type { AssemblyMessage, GraphableMessage } from './AssemblyState';
import { AssemblyMessageType } from './AssemblyState';
import { WsServerHandle } from './WsServerHandle';

const log = makeNamespacedLog('GraphableServerHandle');

export class GraphableServerHandle extends WsServerHandle {
  private graphableData = new EventEmitter<{ data: GraphableMessage }>();

  public constructor(private readonly reset?: () => void) {
    super('graphables');
  }

  public override disconnect() {
    super.disconnect();
    if (this.reset) this.reset();
  }

  public listenForGraphables(
    callback: ListenerType<
      {
        data: GraphableMessage;
      },
      'data'
    >,
  ): () => void {
    return this.graphableData.on('data', callback);
  }

  protected override handleWsMessage<T extends AssemblyMessageType>(
    message: AssemblyMessage<T>,
  ) {
    switch (message.type) {
      case AssemblyMessageType.Graphable: {
        this.graphableData.emit('data', message.payload as GraphableMessage);

        break;
      }
      default:
        log.info(
          `uncategorized`,
          `Undandled message type: '${message.type}'`,
          message.payload,
        );
    }
  }
}

export function getGraphableServerHandle(): GraphableServerHandle {
  return globalCache(`graphableServerHandle`, (item) => {
    const websocketConnection = new GraphableServerHandle(item.reset);

    return websocketConnection;
  });
}
